import React from 'react';

import './PageBanner.css';

function PageBanner() {
  return (
    <div className='page-banner'>
      <div className='page-banner-text'>Smart Certificates For Smart Organizations</div>
    </div>
  );
}

export default PageBanner;
